/**
 * mk-karriere-prefill.js
 * Befüllt das „Bewerbung für"-Feld des Bewerbungsformulars mit dem Stellentitel,
 * wenn der Job-CTA „Stellenangebot ansehen" mit ?stelle=<Titel> verlinkt
 * (z. B. /pages/karriere?stelle=Barista%20Service#bewerbung).
 *
 * Light-DOM, defer-geladen. Graceful: ohne ?stelle passiert nichts → reiner
 * #bewerbung-Scroll. Ziel-Feld: contact[Bewerbung für] (Form-Builder mk-form-field
 * ODER Flag-Fallback-Markup; data-mk-position als zusätzlicher Hook).
 */
(function () {
  var stelle = new URLSearchParams(window.location.search).get('stelle');
  if (!stelle) return;

  function fill() {
    var input =
      document.querySelector('input[name="contact[Bewerbung für]"]') ||
      document.querySelector('input[data-mk-position]');
    if (input && !input.value) input.value = stelle;
  }

  if (document.readyState !== 'loading') {
    fill();
  } else {
    document.addEventListener('DOMContentLoaded', fill);
  }
})();
